import { Route } from '@angular/router';
import { PublicComponent } from './public.component';

export const publicRoutes: Route[] = [
  {
    path: 'public',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'register',
        pathMatch: 'full',
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./register/register.component').then(
            (m) => m.RegisterComponent,
          ),
      },
      {
        path: 'check-status',
        loadComponent: () =>
          import('./check-status/check-status.component').then(
            (m) => m.CheckStatusComponent,
          ),
      },
      {
        path: 'confirm-email-change',
        loadComponent: () =>
          import('./confirm-email-change/confirm-email-change.component').then(
            (m) => m.ConfirmEmailChangeComponent,
          ),
      },
      {
        path: 'password-reset',
        loadComponent: () =>
          import('./password-reset/password-reset.component').then(
            (m) => m.PasswordResetComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'register',
      },
    ],
  },
];
